import { FormikProps } from 'formik';

import { WorksiteLocationFormValues, MainLocation } from './WorksiteLocation';

export const getBillLocationValue = (
  formik: FormikProps<WorksiteLocationFormValues> | undefined,
  mainLocation: MainLocation,
  key:
    | 'country'
    | 'state'
    | 'internationalStateName'
    | 'city'
    | 'internationalCityName'
    | 'address'
    | 'zip',
) => {
  const billing = formik?.values?.billing;
  const work = formik?.values?.work;

  if (work?.locationSameAsMain) {
    return billing?.locationSameAsWork ? mainLocation[key] : billing?.[key];
  }

  return billing?.locationSameAsWork ? work?.[key] : billing?.[key];
};

export const getWorkLocationValue = (
  formik: FormikProps<WorksiteLocationFormValues>,
  mainLocation: MainLocation,
  key:
    | 'country'
    | 'state'
    | 'internationalStateName'
    | 'city'
    | 'internationalCityName'
    | 'address'
    | 'zip',
) => {
  const {
    values: { work },
  } = formik;

  return work.locationSameAsMain ? mainLocation[key] : work[key];
};
